define.alias("shared/components/shared/linkinbio/modal/multi-link", "media/components/shared/linkinbio/modal/multi-link");